$(function () {
	$('input.scroll_btn_').click(function () {
			var speed = 500;
			$("html, body").animate({ scrollTop: 450 }, speed, "swing");
			return false;
	});
});

// ヘッダースクロールに応じてフェード
$(function() {
	$(window).on('load reload resize scroll', function() {
		var $header = $('#top-head');
		// Nav Fixed
		if (window.matchMedia( '(min-width: 769px)' ).matches) {
			if ($(window).scrollTop() > 500) {
			$header.addClass('fixed');
			} else {
			$header.removeClass('fixed');
			}
		} else {
			$header.removeClass('fixed');
			if ($(window).scrollTop() > 500) {
				$header.addClass('sp-fixed');
				// $('.logo').addClass('fadeOut');
				// $('.sp_login').addClass('fadeOut');
			} else {
				$header.removeClass('sp-fixed');
				// $('.logo').removeClass('fadeOut');
				// $('.sp_login').removeClass('fadeOut');
			}
		}
});


$(function() {
	var $header = $('#top-head');
	var $body = $('body');
	var scrollTop;

	//スクロールを固定
	function bodyFixedOn() {
		scrollTop = $(window).scrollTop();
		
		$body.css({
			position: 'fixed',
			top: -scrollTop
		});
	}
	//スクロールの固定を解除
	function bodyFixedOff() {
		$body.css({
			position: '',
			top: ''
		});	
		$(window).scrollTop(scrollTop);
	}


	// メニューボタン押した時
	$('#nav-toggle').click(function(){
		$header.toggleClass('open');
		if($header.hasClass('open')){
			$('.logo').removeClass('fadeOut');
			$('.sp_login').removeClass('fadeOut');
		}
	});
	
});
  
  
  $(function(){
	var state = false;
	var scrollpos;
  
	$('#nav_toggle').on('click', function(){
	  if(state == false) {
		scrollpos = $(window).scrollTop();
		$('body').addClass('fixed').css({'position': 'fixed','top': -scrollpos});
		$('.nav').addClass('open');
		state = true;
	  } else {
		$('body').removeClass('fixed').css({'position': '', 'top': ''});
		window.scrollTo( 0 , scrollpos );
		$('.nav').removeClass('open');
		state = false;
	  }
	});
  
  });
  
  /* SP 招待状をつくるボタン ー*/
  $(function() {
	var $header = $('#start_dear');
	// Nav Fixed
	$(window).scroll(function() {
	  if ($(window).scrollTop() > 200) {
		$header.addClass('fixed_start_dear');
	  } else {
		$header.removeClass('fixed_start_dear');
	  }
	});
  });
  
$(function() {
	var h = $(window).height();
	var w = $(window).width();
	$('#loader-bg_ ,#loading_').width(w).height(h).css('display','block');
});
$(window).on('load', function () { //全ての読み込みが完了したら実行
    stoploading_()
});
function stoploading_() {
    $('#loader-bg_').delay(2000).fadeOut(800);
    $('#loading_').delay(1800).fadeOut(300);
    setTimeout(function() {
        $("#login_").trigger('unlockLogin', arguments);
    }, 2000);
}

  /* pagetop */
  $(function() {
	var topBtn = $('#page_top');
	// topBtn.hide();
	// //スクロールが100に達したらボタン表示
	// $(window).scroll(function () {
	//   if ($(this).scrollTop() > 100) {
	//     topBtn.fadeIn();
	//   } else {
	//     topBtn.fadeOut();
	//   }
	// });
	//スクロールしてトップ
	topBtn.click(function () {
	  $('body,html').animate({
		  scrollTop: 0
	  }, 500);
	  return false;
	});
  });
  
  
  /* インスタ */
  // var feed = new Instafeed({
  //     clientId: '57be5b25c30342e2b7df917ead788184',
  //     get: 'user',
  //     userId: '7417316297',
  //     accessToken:'7417316297.57be5b2.80f2cf7902a743a3aed0c08d86c40c78',
  //     links: true,
  //     limit: 18, // 取得件数
  //     resolution:'thumbnail', // thumbnail (default) - 150x150 | low_resolution - 306x306 | standard_resolution - 612x612
  //     template: '<a href="{{link}}"><img src={{image}} alt={{caption}}></a>' // 画像URL：{{image}} リンク：{{link}} キャプションテキスト{{caption}} いいね数：{{likes}} コメント数：{{comments}}
  // });
  // feed.run();
  
  
  
  
  
  // ----------------------------
  // アニメーション--------------
  // ----------------------------
  
  // cover スライダー -------------------------------------------
  $(document).ready(function() {
  	if ( $('#p_slider,#p_slider_sp').length ) {
		$('#p_slider,#p_slider_sp').bxSlider({
			mode: 'fade',
			auto: true,
			pager: false,
			control: false,
			speed: 6000,
			touchEnabled: false,
			onSliderLoad: function(){
				$("ul.bxslider li span").css("visibility", "visible");
			}
		});
	}
  });
  
  // about スライダー -------------------------------------------
  
// $(document).ready(function() {
//   $('#about_slider').bxSlider({
//     minSlides: 1,
//     maxSlides: 1,
//     moveSlides: 1,
//     loop: true,
//     auto: true,
//     // slideWidth: 900,
//     pause: 5500,
//     pagerCustom: '.custom-thumb',
//     controls: true,
//     slideMargin: 100
//   });
// });
$(function() {
  if ( !$('#about_slider').length ) return false;
  if (window.matchMedia( '(min-width: 768px)' ).matches) {
    var userAgent = window.navigator.userAgent.toLowerCase();
    if(userAgent.indexOf('chrome') != -1) {
      $('#about_slider').bxSlider({
          minSlides: 1,
          maxSlides: 1,
          moveSlides: 1,
          loop: true,
          auto: true,
          // slideWidth: 900,
          pause: 5500,
          pagerCustom: '.custom-thumb',
          controls: true,
          slideMargin: 100,
          touchEnabled: false
      });
    }
    else {
      $('#about_slider').bxSlider({
          minSlides: 1,
          maxSlides: 1,
          moveSlides: 1,
          loop: true,
          auto: true,
          // slideWidth: 900,
          pause: 5500,
          pagerCustom: '.custom-thumb',
          controls: true,
          slideMargin: 100,
          touchEnabled: true
      });
    }
  }
  else {
  // if(window.matchMedia( '(max-width: 768px)' ).matches) {
      $('#about_slider').bxSlider({
          minSlides: 1,
          maxSlides: 1,
          moveSlides: 1,
          loop: true,
          auto: true,
          // slideWidth: 900,
          pause: 5500,
          pagerCustom: '.custom-thumb',
          controls: true,
          slideMargin: 100,
          touchEnabled: true
      });
  // }
	}
});
  
  
  // template スライダー -------------------------------------------
  
  // $(document).ready(function() {
  //     $('#template_slider li:last-child').prependTo('#template_slider');
  //   $('#template_slider').bxSlider({
  //     minSlides: 1,
  //     maxSlides: 3,
  //     moveSlides: 1,
  //     // auto: true,
  //     slideWidth: 240,
  //     pause: 4000,
  //     controls: false,
  //     captions: true,
  //     slideMargin: 40
  //   });
  // });
  
  window.onload = function() {
	var mySwiper = new Swiper('.swiper-container',{
	  //オプションをここに:
	  // mode:'horizontal',
	  loop: !0,
	  slidesPerView: 'auto',
	  // loopedSlides: '5',
	  initialSlide: 1,
	  spaceBetween: 16,
	  watchActiveIndex: !0,
	  resizeReInit: true,
	  paginationClickable: true,
	  hideOnClick: false,
	  navigation: {
	  nextEl: '.swiper-button-next',
	  prevEl: '.swiper-button-prev',
	  },
	  autoplay: {
		  delay: 5000,
		  disableOnInteraction: false
		},
	  //etc..
	});
  }
  
  /* scroll img effect ---------------------------------------- */
  
  // カバー画像 cover fade-in
  $(document).ready(function(){
	$('.imgEffect_fadeIn').css('visibility','hidden');
	$(window).scroll(function(){
	  var windowHeight = $(window).height(),
	  topWindow = $(window).scrollTop();
	$('.imgEffect_fadeIn').each(function(){
	  var objectPosition = $(this).offset().top;
	  if(topWindow > objectPosition - windowHeight + 0){
		$(this).addClass("imgEffectAnime_fadeIn");
	  }
	 });
	});
  });
  
  
  // top-bottom
  
  $(document).ready(function(){
	if (window.matchMedia( '(min-width: 481px)' ).matches) {
	  $('.imgEffect').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 350){
		  $(this).addClass("imgEffectAnime");
		}
	  });
	  });
	}
	else{//スマホ環境の場合
	  $('.imgEffect').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 50){
		  $(this).addClass("imgEffectAnime");
		}
	   });
	  });
	}
  });
  
  // left - right
  
  $(document).ready(function(){
	if (window.matchMedia( '(min-width: 481px)' ).matches) {
	  $('.imgEffect_left_right').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_left_right').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 250){
		  $(this).addClass("imgEffectAnime_left_right");
		}
	   });
	  });
	}
	else{//スマホ環境の場合
	  $('.imgEffect_left_right').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_left_right').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 50){
		  $(this).addClass("imgEffectAnime_left_right");
		}
	   });
	  });
	}
  });
  
  // right - left
  
  $(document).ready(function(){
	if (window.matchMedia( '(min-width: 481px)' ).matches) {
	  $('.imgEffect_right_left').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_right_left').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 250){
		  $(this).addClass("imgEffectAnime_right_left");
		}
	   });
	  });
	}
	else{//スマホ環境の場合
  
	  $('.imgEffect_right_left').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_right_left').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 50){
		  $(this).addClass("imgEffectAnime_right_left");
		}
	   });
	  });
	}
  
  });
  
  // bottom - top
  
  $(document).ready(function(){
	if (window.matchMedia( '(min-width: 481px)' ).matches) {
	  $('.imgEffect_bottom_top').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_bottom_top').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 400){
		  $(this).addClass("imgEffectAnime_bottom_top");
		}
	   });
	  });
	}
	else{//スマホ環境の場合
  
	  $('.imgEffect_bottom_top').css('visibility','hidden');
	  $(window).scroll(function(){
		var windowHeight = $(window).height(),
		topWindow = $(window).scrollTop();
	  $('.imgEffect_bottom_top').each(function(){
		var objectPosition = $(this).offset().top;
		if(topWindow > objectPosition - windowHeight + 50){
		  $(this).addClass("imgEffectAnime_bottom_top");
		}
	   });
	  });
	}
  
  });
  
  // cover  rsvp 背景 fade-in
  
  $(document).ready(function(){
	$('.imgEffect_bg_cover').css('visibility','hidden');
	$(window).scroll(function(){
	  var windowHeight = $(window).height(),
	  topWindow = $(window).scrollTop();
	$('.imgEffect_bg_cover').each(function(){
	  var objectPosition = $(this).offset().top;
	  if(topWindow > objectPosition - windowHeight + 400){
		$(this).addClass("imgEffectAnime_bg_cover");
	  }
	 });
	});
  });
	
// デザインテンプレートページ　無料テンプレ一覧
$(document).ready(function(){
  // slider
  $slick_slider = $('.slider_invitation, .slider_thanks');
  if ($slick_slider.length) {
	  settings_slider = {
		  centerMode: true,
		  dots: true,
		  focusOnSelect: true,
		  responsive:[
			  {
				  breakpoint: 767,
				  settings:{
					  slidesToShow: 3,
					  centerPadding: '200px',
				  }
			  },
			  {
				  breakpoint: 480,
				  settings:{
					  centerPadding: '40px',
				  }
			  },
		  ]
	  }
	  slick_on_mobile( $slick_slider, settings_slider);
	  // slick on mobile
	  function slick_on_mobile(slider, settings){
		  $(window).on('load resize', function() {
			  if ($(window).width() > 767) {
				  if (slider.hasClass('slick-initialized')) {
					  slider.slick('unslick');
				  }
				  return
			  }
			  if (!slider.hasClass('slick-initialized')) {
				  return slider.slick(settings);
			  }
		  });
	  };
  }

});


// デザインテンプレートsp時スライド
$(function() {
	var swiper;
	$(window).on('load resize', function () {
		var w = $(window).width();
		if (w <= 767){
			if(swiper) {
				return ;
			}else {
				swiper = new Swiper(".swiper", {
					loop: true,
					loopAdditionalSlides: 1,
					centeredSlides: true,
					slidesPerView: 1.3,
					spaceBetween: 25,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		}else {
			if (swiper) {
				swiper.destroy();
				swiper = undefined;
			} 
		} 
	});
});

// アコーディオン
$(function() {
	$('.c-accordion__ttl').on('click', function(){
		$(this).toggleClass('is_active');
		$(this).next('.c-accordion__content').slideToggle();
	})
});


$(function() {
	$(window).on("load reload", function() {
		$('.p-cover-contents .p-img-wrap .p-keyvisual').animate({
      'marginTop': '-30px'
    	},
			3000,
			"swing"
		);
	});
});


// トップページキービジュアル画像切り替え
$(function(){
  $(".p-cover-contents .p-img-wrap .p-keyvisual:not(:first-child)").hide();
  setInterval(function() {
    $(".p-cover-contents .p-img-wrap .p-keyvisual:first-child").fadeOut("slow").next().fadeIn("slow").end().appendTo(".p-cover-contents .p-img-wrap");
  },5000);
});

// 無料ではじめるボタンsp時出現
$(function() {
	$(window).scroll(function() {
		var w = $(window).width();
		if (w <= 768) {
			if ($(window).scrollTop() > 200) {
			$('.freestart__fixed').addClass('slide-in');
			} else {
			$('.freestart__fixed').removeClass('slide-in');
			}
		}
	});
});

// iOSブラウザバック対応
window.onpageshow = function(event) {
	if (event.persisted) {
		window.location.reload();
	}
};

// お知らせエリアクリックで消える
$(function() {
	$('.p-delete-notice').on('click', function() {
		$('.p-notice-area').hide();
		if($(window).width() <= 767) {
			console.log('消す');
			$('.page-top .cover-area').css('padding-top', '40px');
			$('.page-top .cover-area .p-english-ttl-wrap').css('top', '28%');
		}
	});
});




$(function() {
	var h = $(window).height();
	var w = $(window).width();
$('#loader-bg_ ,#loading_').width(w).height(h).css('display','block');
});
$(window).on('load', function () { //全ての読み込みが完了したら実行
	stoploading_()
});
});



